const styles = {
  section: {
    paddingTop: {
      xs: '32px',
      lg: '84px',
      xl: '84px',
    },
    paddingBottom: {
      xs: '40px',
      lg: '84px',
      xl: '84px',
    },
  },
  contentWrapper: (theme) => ({
    display: 'flex',
    alignItems: {
      xs: 'center',
      lg: 'flex-end',
    },
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
  }),
  message: (hasSecondButton) => ({
    ...(!hasSecondButton && { textAlign: 'center' }),
    color: 'kit.text.black',
    order: '0',
    marginBottom: {
      xs: '24px',
      md: '8px',
    },
    marginRight: {
      md: '45px',
    },
  }),
  leftLink: {
    textDecoration: 'none',
    my: 1,
    marginRight: {
      xs: '0',
      md: '16px',
    },
    order: {
      xs: '3',
      md: '2',
    },
  },
  rightLink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    marginBottom: {
      md: '0',
    },
    order: {
      xs: '2',
      md: '3',
    },
  },
};

export default styles;
